import { render, staticRenderFns } from "./ClassLayout.vue?vue&type=template&id=c4e62e46"
import script from "./ClassLayout.vue?vue&type=script&lang=js"
export * from "./ClassLayout.vue?vue&type=script&lang=js"
import style0 from "./ClassLayout.vue?vue&type=style&index=0&id=c4e62e46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports